<template>
        <div>
            <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        tbody-classes="list"
                        :data="projects">
                <template slot="columns">
                <th>Parametro</th>
                <th>Valor</th>
                </template>

                <template slot-scope="{row}">
                <td class="id">
                    {{row.id}}
                </td>
                <td class="description">
                    {{row.description}}
                </td>
                </template>

            </base-table>
            </div>    
            <pre>{{ projects }}</pre>
        </div>
</template>
<script>
export default {
    name: "table-parameters",
    props: ['parameters'],
}
</script>
<style>
</style>
